import { render, staticRenderFns } from "./LoggedEmail.vue?vue&type=template&id=213f8e96&scoped=true&"
import script from "./LoggedEmail.vue?vue&type=script&lang=js&"
export * from "./LoggedEmail.vue?vue&type=script&lang=js&"
import style0 from "./LoggedEmail.vue?vue&type=style&index=0&id=213f8e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f8e96",
  null
  
)

export default component.exports